import { THEMES } from '../../../../configs/LayoutConfig';
import ConstChart from '../../../common/mixChart/Const';
import { formatTextFloat } from '../../../helpers/Text';
import { LEVELS } from '../Const';

export const incomeStatementInsuranceMapping = {
  revenueFromInsurancePremium: 'isi103',
  grossWrittenPremium: 'isi51',
  reinsurancePremiumAssumned: 'isi52',
  increaseDecreaseInUnearnedPremiumReserveForDirectInsuranceAndOutwardReinsurance:
    'isi104',
  deductions: 'isi53',
  reinsurancePremiumCeded: 'isi54',
  increaseDecreaseInReinsurancePremiumCededReserve: 'isi175',
  premiumDeductions: 'isi55',
  premiumReturns: 'isi56',
  otherDeductions: 'isi57',
  netRevenueOfInsurancePremium: 'isi105',
  increaseInUnearnedPremiumReserveAndTechinicalReserve: 'isi58',
  commissionIncomeFromOutwardReinsuranceAndOtherIncomeFromInsuranceActivities:
    'isi59',
  commissionOnReinsuranceCeded: 'isi106',
  otherIncome: 'isi60',
  incomeOnReinsuranceAssumed: 'isi61',
  incomeOnReinsuranceCeded: 'isi62',
  incomeFromOtherAcitvites: 'isi63',
  netSalesFromInsuranceBusiness: 'isi64',
  claimExpense: 'isi176',
  totalClaimExpense: 'isi177',
  claimAndMaturityPaymentExpenses: 'isi65',
  claimExpensesForReinsuranceAssumed: 'isi66',
  claimExpenseDeductions: 'isi67',
  recoveriesFormReinsuranceCeded: 'isi68',
  subrogationRecoveries: 'isi69',
  salvages: 'isi70',
  claimRecoveriesFromOutwardReinsurance: 'isi107',
  claimExpensesOnRetainedRisks: 'isi71',
  increaseDecreaseInMathematicReserves: 'isi108',
  increaseDecreaseInClaimReserve: 'isi73',
  increaseDecreaseInClaimReserveForDirectInsuranceAndInwardInsurance: 'isi109',
  increaseDecreaseInClaimReserveForOutwardInsurance: 'isi110',
  totalInsuranceClaimSettlementExpenses: 'isi111',
  claimExpensesUsingCatastropheReserve: 'isi72',
  provisionForCatastropheReserve: 'isi74',
  otherInsuranceOperatingExpenses: 'isi75',
  otherUnderwritingExpenses: 'isi76',
  commissions: 'isi77',
  expenseOfRecourseAgainstTheThirdParty: 'isi78',
  expenseOfHandlingFullyIndemnifiedGoods: 'isi79',
  riskMinimizationExpenses: 'isi80',
  lossAdjustingFeeRiskAssessment: 'isi81',
  otherInsuranceSellingExpenses: 'isi112',
  others: 'isi82',
  otherReinsuranceAssumedExpenses: 'isi83',
  otherReinsuranceCededExpenses: 'isi84',
  otherDirectInsuranceOperatingExpenses: 'isi85',
  totalDirectInsuranceOperatingExpenses: 'isi86',
  grossInsuranceOperatingProfit: 'isi87',
  netOperatingIncomeFromBankingActivities: 'isi90',
  incomeFromBankingActivities: 'isi88',
  expensesFromBankingActivities: 'isi89',
  profitFromRealEstateInvestmentActivities: 'isi178',
  revenueFromRealEstate: 'isi179',
  costOfRealEstate: 'isi173',
  profitFromFinancialActivities: 'isi100',
  financialIncome: 'isa6',
  financialExpenses: 'isa7',
  gainLossFromJointVentures: 'isa102',
  netOperatingIncomeFromOtherActivities: 'isi93',
  revenueFromOtherActivities: 'isi91',
  expensesFromOtherActivities: 'isi92',
  sellingExpenses: 'isa9',
  generalAndAdminExpenses: 'isa10',
  generalAndAdministrativeExpensesOfInsuranceOperation: 'isi94',
  generalAndAdministrativeExpensesOfBankingOperation: 'isi95',
  generalAndAdministrativeExpensesOfOthersOperation: 'isi96',
  netOperatingProfitFromInsuranceOperation: 'isi97',
  lossFromLifeInsurance: 'isi113',
  netProfitFromNonLifeInsurance: 'isi114',
  netProfitFromBankOperation: 'isi98',
  netProfitFromOthersOperation: 'isi99',
  netOtherIncomeExpenses: 'isa12',
  netOtherIncomeOtherIncome: 'isa13',
  netOtherIncomeOtherExpenses: 'isa14',
  incomeFromInvestmentsInOtherEntities: 'isa15',
  netAccountingProfitLossBeforeTax: 'isa16',
  equalisationReserve: 'isi101',
  businessIncomeTaxExpenses: 'isa19',
  businessIncomeTaxCurrent: 'isa17',
  businessIncomeTaxDeferred: 'isa18',
  netProfitLossAfterTax: 'isa20',
  minorityInterests: 'isa21',
  attributableToParentCompany: 'isa22',
  EPS_basis: 'isa23',
  netProfit: 'isa20',
  netProfitMargin: 'rtq29',
};

export const insuranceRows = Object.keys(incomeStatementInsuranceMapping).map(
  key => {
    const defaultItem = {
      id: incomeStatementInsuranceMapping[key],
      i18nKey: key,
      level: LEVELS.PARENT,
    };
    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.revenueFromInsurancePremium
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.grossWrittenPremium,
          incomeStatementInsuranceMapping.reinsurancePremiumAssumned,
          incomeStatementInsuranceMapping.increaseDecreaseInUnearnedPremiumReserveForDirectInsuranceAndOutwardReinsurance,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.grossWrittenPremium,
        incomeStatementInsuranceMapping.reinsurancePremiumAssumned,
        incomeStatementInsuranceMapping.increaseDecreaseInUnearnedPremiumReserveForDirectInsuranceAndOutwardReinsurance,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.deductions
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.reinsurancePremiumCeded,
          incomeStatementInsuranceMapping.increaseDecreaseInReinsurancePremiumCededReserve,
          incomeStatementInsuranceMapping.otherDeductions,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.reinsurancePremiumCeded,
        incomeStatementInsuranceMapping.otherDeductions,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.increaseDecreaseInReinsurancePremiumCededReserve
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          incomeStatementInsuranceMapping.premiumDeductions,
          incomeStatementInsuranceMapping.premiumReturns,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.premiumDeductions,
        incomeStatementInsuranceMapping.premiumReturns,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.commissionIncomeFromOutwardReinsuranceAndOtherIncomeFromInsuranceActivities
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.commissionOnReinsuranceCeded,
          incomeStatementInsuranceMapping.otherIncome,
        ],
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.otherIncome
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          incomeStatementInsuranceMapping.incomeOnReinsuranceAssumed,
          incomeStatementInsuranceMapping.incomeOnReinsuranceCeded,
          incomeStatementInsuranceMapping.incomeFromOtherAcitvites,
        ],
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.commissionOnReinsuranceCeded
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.incomeOnReinsuranceAssumed,
        incomeStatementInsuranceMapping.incomeOnReinsuranceCeded,
        incomeStatementInsuranceMapping.incomeFromOtherAcitvites,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.claimExpense
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.totalClaimExpense,
          incomeStatementInsuranceMapping.claimExpenseDeductions,
        ],
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.totalClaimExpense
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          incomeStatementInsuranceMapping.claimAndMaturityPaymentExpenses,
          incomeStatementInsuranceMapping.claimExpensesForReinsuranceAssumed,
        ],
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.claimExpenseDeductions
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          incomeStatementInsuranceMapping.recoveriesFormReinsuranceCeded,
          incomeStatementInsuranceMapping.subrogationRecoveries,
          incomeStatementInsuranceMapping.salvages,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.claimAndMaturityPaymentExpenses,
        incomeStatementInsuranceMapping.claimExpensesForReinsuranceAssumed,
        incomeStatementInsuranceMapping.recoveriesFormReinsuranceCeded,
        incomeStatementInsuranceMapping.subrogationRecoveries,
        incomeStatementInsuranceMapping.salvages,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.increaseDecreaseInClaimReserve
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.increaseDecreaseInClaimReserveForDirectInsuranceAndInwardInsurance,
          incomeStatementInsuranceMapping.increaseDecreaseInClaimReserveForOutwardInsurance,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.increaseDecreaseInClaimReserveForDirectInsuranceAndInwardInsurance,
        incomeStatementInsuranceMapping.increaseDecreaseInClaimReserveForOutwardInsurance,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.otherInsuranceOperatingExpenses
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.otherUnderwritingExpenses,
          incomeStatementInsuranceMapping.otherReinsuranceAssumedExpenses,
          incomeStatementInsuranceMapping.otherReinsuranceCededExpenses,
          incomeStatementInsuranceMapping.otherDirectInsuranceOperatingExpenses,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.otherReinsuranceAssumedExpenses,
        incomeStatementInsuranceMapping.otherReinsuranceCededExpenses,
        incomeStatementInsuranceMapping.otherDirectInsuranceOperatingExpenses,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.otherUnderwritingExpenses
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          incomeStatementInsuranceMapping.commissions,
          incomeStatementInsuranceMapping.expenseOfRecourseAgainstTheThirdParty,
          incomeStatementInsuranceMapping.expenseOfHandlingFullyIndemnifiedGoods,
          incomeStatementInsuranceMapping.riskMinimizationExpenses,
          incomeStatementInsuranceMapping.lossAdjustingFeeRiskAssessment,
          incomeStatementInsuranceMapping.sellingExpenses,
          incomeStatementInsuranceMapping.others,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.commissions,
        incomeStatementInsuranceMapping.expenseOfRecourseAgainstTheThirdParty,
        incomeStatementInsuranceMapping.expenseOfHandlingFullyIndemnifiedGoods,
        incomeStatementInsuranceMapping.riskMinimizationExpenses,
        incomeStatementInsuranceMapping.lossAdjustingFeeRiskAssessment,
        incomeStatementInsuranceMapping.sellingExpenses,
        incomeStatementInsuranceMapping.others,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.netOperatingIncomeFromBankingActivities
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.incomeFromBankingActivities,
          incomeStatementInsuranceMapping.expensesFromBankingActivities,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.incomeFromBankingActivities,
        incomeStatementInsuranceMapping.expensesFromBankingActivities,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.profitFromRealEstateInvestmentActivities
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.revenueFromRealEstate,
          incomeStatementInsuranceMapping.costOfRealEstate,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.revenueFromRealEstate,
        incomeStatementInsuranceMapping.costOfRealEstate,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.profitFromFinancialActivities
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.financialIncome,
          incomeStatementInsuranceMapping.financialExpenses,
          incomeStatementInsuranceMapping.gainLossFromJointVentures,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.financialIncome,
        incomeStatementInsuranceMapping.financialExpenses,
        incomeStatementInsuranceMapping.gainLossFromJointVentures,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.netOperatingIncomeFromOtherActivities
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.revenueFromOtherActivities,
          incomeStatementInsuranceMapping.expensesFromOtherActivities,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.revenueFromOtherActivities,
        incomeStatementInsuranceMapping.expensesFromOtherActivities,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.generalAndAdminExpenses
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfInsuranceOperation,
          incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfBankingOperation,
          incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfOthersOperation,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfInsuranceOperation,
        incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfBankingOperation,
        incomeStatementInsuranceMapping.generalAndAdministrativeExpensesOfOthersOperation,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.netOperatingProfitFromInsuranceOperation
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.lossFromLifeInsurance,
          incomeStatementInsuranceMapping.netProfitFromNonLifeInsurance,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.lossFromLifeInsurance,
        incomeStatementInsuranceMapping.netProfitFromNonLifeInsurance,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.netOtherIncomeExpenses
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.netOtherIncomeOtherIncome,
          incomeStatementInsuranceMapping.netOtherIncomeOtherExpenses,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.netOtherIncomeOtherIncome,
        incomeStatementInsuranceMapping.netOtherIncomeOtherExpenses,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    if (
      incomeStatementInsuranceMapping[key] ===
      incomeStatementInsuranceMapping.businessIncomeTaxExpenses
    ) {
      return {
        ...defaultItem,
        children: [
          incomeStatementInsuranceMapping.businessIncomeTaxCurrent,
          incomeStatementInsuranceMapping.businessIncomeTaxDeferred,
        ],
      };
    }

    if (
      [
        incomeStatementInsuranceMapping.businessIncomeTaxCurrent,
        incomeStatementInsuranceMapping.businessIncomeTaxDeferred,
      ].includes(incomeStatementInsuranceMapping[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
      };
    }

    return defaultItem;
  },
);

const COMMON_SETTINGS = {
  HEIGHT: 120,
  WIDTH: 500,
  MARGIN: { left: 60, right: 60, top: 10, bottom: 30 },
  TEXT_COLOR: '#ffffff',
  TEXT_SM_SIZE: 10,
  TEXT_MD_SIZE: 12,
  TEXT_LG_SIZE: 14,
  BIG_SIZE: 20,
  KEY_CHART: 1,
  MIN_WIDTH: 500,
};

export const SETTINGS = {
  Dark: {
    ...COMMON_SETTINGS,
    COLUMN_ONE_COLOR: '#3581b8',
    COLUMN_TWO_COLOR: '#47ccc7',
    COLUMN_THREE_COLOR: '#f1ffe7',
    COLUMN_FOUR_COLOR: '#f5d0c5',
    COLUMN_FIVE_COLOR: '#ee6352',
    COLOR_CIRCLE_MARKER_LINE: '#f5d0c5',
  },
  Light: {
    ...COMMON_SETTINGS,
    COLUMN_ONE_COLOR: '#3581b8',
    COLUMN_TWO_COLOR: '#00c6ba',
    COLUMN_THREE_COLOR: '#f8bc06',
    COLUMN_FOUR_COLOR: '#f5d0c5',
    COLUMN_FIVE_COLOR: '#ee6352',
    COLOR_CIRCLE_MARKER_LINE: '#f5d0c5',
  },
  Classic: {
    ...COMMON_SETTINGS,
    COLUMN_ONE_COLOR: '#3581b8',
    COLUMN_TWO_COLOR: '#47ccc7',
    COLUMN_THREE_COLOR: '#f1ffe7',
    COLUMN_FOUR_COLOR: '#f5d0c5',
    COLUMN_FIVE_COLOR: '#ee6352',
    COLOR_CIRCLE_MARKER_LINE: '#f5d0c5',
  },
};

const xAccessor = d => d.time;
const xExtents = 'time';

const getHoverTooltipChart = tooltips =>
  ConstChart.hoverTooltipFunc(
    null,
    null,
    null,
    tooltips.map(tooltip => {
      return ConstChart.setContentTooltip(
        '',
        tooltip.i18nKey,
        d => {
          return { tooltipValue: formatTextFloat(d[tooltip.key]) };
        },
        '#000',
        true,
      );
    }),
  );
const yGrid = {
  innerTickSize:
    -1 *
    (COMMON_SETTINGS.WIDTH -
      COMMON_SETTINGS.MARGIN.left -
      COMMON_SETTINGS.MARGIN.right),
  tickStrokeDasharray: 'Solid',
  tickStrokeOpacity: 0.2,
  tickStrokeWidth: 2,
};

const titleYAxisLeft = text => {
  return {
    x: -(COMMON_SETTINGS.MARGIN.left / 2),
    y:
      COMMON_SETTINGS.MARGIN.top +
      (COMMON_SETTINGS.HEIGHT -
        COMMON_SETTINGS.MARGIN.top -
        COMMON_SETTINGS.MARGIN.bottom) /
        2,
    text: text,
  };
};

const yExtents = [
  'netRevenueOfInsurancePremium',
  'netOperatingProfitFromInsuranceOperation',
  'netProfit',
];
const YAxisLeftChart = ConstChart.setConfigYAxis(
  'left',
  'left',
  yGrid,
  titleYAxisLeft(''),
);

const XAxis = { axisAt: 'bottom', orient: 'bottom' };

const seriesGroupChart = theme => {
  const { COLUMN_ONE_COLOR, COLUMN_TWO_COLOR, COLUMN_THREE_COLOR } = SETTINGS[
    theme
  ];
  return [
    {
      type: ConstChart.GROUPCHART,
      yAccessor: [
        d => d.netRevenueOfInsurancePremium,
        d => d.netOperatingProfitFromInsuranceOperation,
        d => d.netProfit,
      ],
      arrayColor: [COLUMN_ONE_COLOR, COLUMN_TWO_COLOR, COLUMN_THREE_COLOR],
    },
  ];
};

const typeCircleMarker = theme => ({
  r: 1,
  fill: SETTINGS[theme].COLUMN_FOUR_COLOR,
  opacity: 1,
  strokeWidth: 0,
});

const seriesLineChart = theme => {
  const { COLUMN_FOUR_COLOR } = SETTINGS[theme];
  return [
    ConstChart.setConfigLineSeries(
      'netProfitMargin',
      COLUMN_FOUR_COLOR,
      ConstChart.CircleMarker,
      typeCircleMarker(theme),
    ),
  ];
};

const titleYAxisRight = text => {
  return {
    x:
      COMMON_SETTINGS.WIDTH -
      COMMON_SETTINGS.MARGIN.left -
      COMMON_SETTINGS.MARGIN.right / 2,
    y:
      COMMON_SETTINGS.MARGIN.top +
      (COMMON_SETTINGS.HEIGHT -
        COMMON_SETTINGS.MARGIN.top -
        COMMON_SETTINGS.MARGIN.bottom) /
        2,
    text: text,
    rotate: 90,
  };
};

const YAxisRightChart = ConstChart.setConfigYAxis(
  'right',
  'right',
  {},
  titleYAxisRight(''),
);

const yExtentsRight = ['netProfitMargin'];

const getChartItems = (tooltips, theme) => [
  ConstChart.setConfigChartItem(
    getHoverTooltipChart(tooltips),
    yExtents,
    YAxisLeftChart,
    XAxis,
    seriesGroupChart(theme),
  ),
  ConstChart.setConfigChartItem(
    null,
    yExtentsRight,
    YAxisRightChart,
    null,
    seriesLineChart(theme),
  ),
];

export const generateChartConfig = ({
  title,
  tooltips,
  listLegendChart,
  theme,
}) =>
  ConstChart.configChartFunc(
    xAccessor,
    xExtents,
    SETTINGS.MARGIN,
    SETTINGS.HEIGHT,
    listLegendChart,
    title,
    getChartItems(tooltips, theme),
  );
